import { AppNavigationBar } from "app-navigation-bar";
import { MapsPortal as View } from "ui-components";

import { BannerHeadline } from "./BannerHeadline";
import { Filters } from "./Filters";
import { LargeView } from "./LargeView";
import { MediumView } from "./MediumView";
import { RowView } from "./RowView";

export const MapsPortal = () => {
	return (
		<AppNavigationBar>
			<View
				slots={{
					BannerHeadline,
					Filters,
					RowView,
					MediumView,
					LargeView,
				}}
			/>
		</AppNavigationBar>
	);
};
